import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            焦点推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            本周不容错过的精选影视内容
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselData.map((item) => (
              <div
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all"
              >
                <div className="relative overflow-hidden aspect-[2/1]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold font-label">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-bold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}